import { render, staticRenderFns } from "./WinnerAlertComponent.vue?vue&type=template&id=650dac3e&scoped=true"
import script from "./WinnerAlertComponent.vue?vue&type=script&lang=js"
export * from "./WinnerAlertComponent.vue?vue&type=script&lang=js"
import style0 from "./WinnerAlertComponent.vue?vue&type=style&index=0&id=650dac3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650dac3e",
  null
  
)

export default component.exports